module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/long-arrow-up.svg?1d2cc00a922b2aeef3d5a87d6722886d";